import { HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { AuthService, WindowRef } from '@spartacus/core';
import { UserProfileFacade } from '@spartacus/user/profile/root';
import { Observable, Subscription } from 'rxjs';

@Injectable()
export class XCustomerSegmentInterceptor implements HttpInterceptor {
  private subscriptions: Subscription = new Subscription();

  constructor(
    protected userProfile: UserProfileFacade,
    protected authService: AuthService,
    protected winRef?: WindowRef
  ) {}

  intercept(request: HttpRequest<unknown>, next: HttpHandler): Observable<HttpEvent<unknown>> {
    if (request.url.includes('/authorizationserver/')) {
      return next.handle(request);
    }
    let professional: string;
    this.subscriptions.add(
      this.authService.isUserLoggedIn().subscribe((isLoggedIn) => {
        if (isLoggedIn) {
          if (this.winRef?.isBrowser() && this.winRef?.localStorage?.getItem('userProfessional') !== null) {
            professional = this.winRef?.localStorage?.getItem('userProfessional') === 'true' ? 'professional=true' : 'default';
          } else {
            this.subscriptions.add(
              this.userProfile.get().subscribe((userData: any) => {
                if (userData !== undefined) {
                  professional = userData?.professional ? 'professional=true' : 'default';
                  this.winRef?.localStorage?.setItem('userProfessional', userData?.professional);
                  this.subscriptions.unsubscribe();
                }
              })
            );
          }
        } else {
          this.winRef?.localStorage?.setItem('userProfessional', 'false');
          professional = 'default';
          this.subscriptions.unsubscribe();
        }
      })
    );
    let newRequest = request;
    if (professional !== undefined) {
      let headers = request.headers.set('x-customer-segment', professional);
      newRequest = request.clone({ headers });
    }
    return next.handle(newRequest);
  }
}
